<template>
    <div class="flex items-end gap-2">
        <div class="flex gap-2 flex-1 overflow-x-auto">
            <div
                class="bg-white flex items-center px-2 rounded-t-md shadow-2xl border border-gray-100 cursor-pointer"
                :class="[has_scroll ? 'opacity-100' : 'opacity-0']"
                @click="() => handleScrollLabels('left')"
            >
                <fa :icon="['fal', 'chevron-left']" class="text-gray-300 text-2xl" />
            </div>
            <div
                id="chatLabelsContainer"
                class="flex items-center ml-auto gap-2 overflow-x-auto hide-scroll"
                ref="chatLabelsContainer"
            >
                <div v-for="(contactGroup, index) in ongoingChats" :key="index" :id="contactGroup?.chatId">
                    <MiniChatLabel
                        :contacts="contactGroup.contacts"
                        @handleChatClick="() => emits('handleClickChat', contactGroup)"
                        :is_active="contactGroup.chatId === activeContactID"
                        :has_scroll="has_scroll"
                        @handleClose="() => emits('handleCloseChat', contactGroup)"
                    />
                </div>
            </div>
            <div
                class="bg-white flex items-center px-2 rounded-t-md shadow-2xl border border-gray-100 cursor-pointer"
                :class="[has_scroll ? 'opacity-100' : 'opacity-0']"
                @click="() => handleScrollLabels('right')"
            >
                <fa :icon="['fal', 'chevron-right']" class="text-gray-300 text-2xl" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { MiniChatLabel } from "./";

const emits = defineEmits(["handleClickChat", "handleCloseChat"]);

const props = defineProps({
    ongoingChats: {
        type: Array,
        default: [],
    },
    has_scroll: {
        type: Boolean,
        default: false,
    },
    activeContactID: {
        type: Number,
        default: 0,
    },
});

const chatLabelsContainer = ref(null);

const handleScrollLabels = (direction) => {
    if (!chatLabelsContainer.value) return;

    const scrollAmount = 14 * 3 * 16 + 8; // [info]: 14rem * 3 + 8px
    const currentScroll = chatLabelsContainer.value.scrollLeft;
    const targetScroll = direction === "left" ? currentScroll - scrollAmount : currentScroll + scrollAmount;

    smoothScroll(chatLabelsContainer.value, targetScroll);
};

const smoothScroll = (element, targetScroll) => {
    const startScroll = element.scrollLeft;
    const startTime = performance.now();
    const duration = 300;

    const scroll = (timestamp) => {
        const currentTime = timestamp - startTime;
        const progress = Math.min(currentTime / duration, 1);
        const easedProgress = easeInOutQuad(progress);

        element.scrollLeft = startScroll + (targetScroll - startScroll) * easedProgress;

        if (currentTime < duration) {
            requestAnimationFrame(scroll);
        }
    };

    requestAnimationFrame(scroll);
};

const easeInOutQuad = (t) => {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
};
</script>
